import { Pipe, PipeTransform } from '@angular/core';
import { DateFormat, PersianDate } from '../persian-date';

@Pipe({
  name: 'pdate'
})
export class PdatePipe implements PipeTransform {

  transform(value: Date | number | string, relative?: boolean | string | DateFormat, exactTime?: boolean): string {
    if (!value) { value = new Date(); }
    else if (!isNaN(+value)) { value = new Date(+value); }
    else if (typeof value == 'string') { value = new Date(!value.includes('Z') && !/[+-]\d\d:\d\d$/.test(value) ? value + 'Z' : value); }

    const pdate = new PersianDate(<any>value);
    if (pdate.isNaN() || pdate.year < 0) { return ''; }
    if (typeof relative == 'string' || typeof relative == 'number') { return pdate.toString(relative); }
    return relative ? PersianDate.relative(<any>value, true, true, false, exactTime) : pdate.toString();
  }
}
